import { Loader2Icon } from 'lucide-react';

import { Button } from '../ui/button';
import { Table } from '../ui/table/table';

import { useQuestion } from '@/features/service-questions/api/get-question';
import { useModalControls } from '@/state/modals';

export const Config = {
  title: 'Question',
};
export function Component({ qid }: { qid: string }) {
  const questionQuery = useQuestion({ qid });
  const { closeModal, openModal } = useModalControls();

  if (questionQuery.isPending) {
    return <Loader2Icon className="h-6 w-6 animate-spin" />;
  }

  const question = questionQuery.data;

  if (!question) {
    return null;
  }

  return (
    <div className="space-y-4">
      <p>{question.text}</p>
      <div className="space-y-4">
        {question.choices && question.choices.length > 0 ? (
          <Table
            data={question.choices}
            columns={[
              {
                title: 'Choix',
                field: 'choice_text',
              },
            ]}
          />
        ) : null}
      </div>
      <div className="flex justify-end">
        <Button
          variant={'secondary'}
          size="sm"
          onClick={() => {
            closeModal();
            openModal({ name: 'edit-question', qid });
          }}
        >
          Modifier
        </Button>
      </div>
    </div>
  );
}
